<template>
  <img src="../../../assets/img/avatars/avatar8.jpg" alt="avatar8">
</template>
